import { __decorate, __param } from 'tslib';
import { InjectionToken, EventEmitter, Optional, Self, Inject, ChangeDetectorRef, ContentChild, ViewChild, Input, HostBinding, Output, TemplateRef, Component, ChangeDetectionStrategy, forwardRef, Pipe, ContentChildren, Directive, NgModule } from '@angular/core';
import { AbstractTuiMultipleControl, EMPTY_ARRAY, isNativeFocused, setNativeFocused, tuiDefaultProp, tuiPure, TUI_FOCUSABLE_ITEM_ACCESSOR, EMPTY_QUERY, itemsQueryListObservable, getOriginalArrayFromQueryList, TUI_DEFAULT_IDENTITY_MATCHER, isPresent, tuiReplayedValueChangesFrom, EMPTY_FUNCTION, TuiPreventDefaultModule, TuiActiveZoneModule, TuiLetModule, TuiMapperPipeModule, TuiHoveredModule } from '@taiga-ui/cdk';
import { isFlat } from '@taiga-ui/kit/utils';
import { NgControl, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { TuiSvgService, TuiTextfieldController, TUI_TEXTFIELD_WATCHED_CONTROLLER, TUI_DATA_LIST_ACCESSOR, TuiHostedDropdownComponent, TuiDataListDirective, TUI_DATA_LIST_HOST, TEXTFIELD_CONTROLLER_PROVIDER, sizeBigger, TuiOptionComponent, TUI_OPTION_CONTENT, TuiSvgModule, TuiHostedDropdownModule, TuiPrimitiveCheckboxModule, TuiDataListModule } from '@taiga-ui/core';
import { TuiStringifiableItem } from '@taiga-ui/kit/classes';
import { TUI_ARROW_MODE, TuiArrowModule } from '@taiga-ui/kit/components/arrow';
import { TuiInputTagComponent, TuiInputTagModule } from '@taiga-ui/kit/components/input-tag';
import { iconBlank } from '@taiga-ui/kit/constants';
import { FIXED_DROPDOWN_CONTROLLER_PROVIDER } from '@taiga-ui/kit/providers';
import { TUI_ITEMS_HANDLERS } from '@taiga-ui/kit/tokens';
import { CommonModule } from '@angular/common';
import { TuiMultiSelectOptionComponent, TuiMultiSelectOptionModule } from '@taiga-ui/kit/components/multi-select-option';
import { PolymorpheusComponent, PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/core';
import * as ɵngcc2 from '@taiga-ui/cdk';
import * as ɵngcc3 from '@taiga-ui/kit/components/input-tag';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@angular/common';
import * as ɵngcc6 from '@tinkoff/ng-polymorpheus';

function TuiMultiSelectComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵclassProp("t-group_fullsize", _r0.labelOutside);
    ɵngcc0.ɵɵproperty("context", ctx_r1.context)("content", ctx_r1.valueContent);
} }
function TuiMultiSelectComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click.prevent", function TuiMultiSelectComponent_div_8_Template_div_click_prevent_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onArrowClick(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("content", ctx_r2.arrow);
} }
const _c0 = ["*"];
const _c1 = ["tuiMultiSelectGroup", ""];
function TuiMultiSelectGroupComponent_ng_container_0_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 2);
    ɵngcc0.ɵɵlistener("click", function TuiMultiSelectGroupComponent_ng_container_0_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const value_r1 = ɵngcc0.ɵɵnextContext().tuiLet; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onClick(value_r1); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵelement(2, "tui-primitive-checkbox", 3);
    ɵngcc0.ɵɵelementStart(3, "span", 4);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r1 = ɵngcc0.ɵɵnextContext().tuiLet;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("size", ctx_r2.size)("disabled", !!ɵngcc0.ɵɵpipeBind1(1, 5, ctx_r2.disabled$));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("size", ctx_r2.checkboxSize)("value", value_r1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.label);
} }
function TuiMultiSelectGroupComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TuiMultiSelectGroupComponent_ng_container_0_button_1_Template, 5, 7, "button", 1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.label && !ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r0.empty$));
} }
const TUI_MULTI_SELECT_DEFAULT_OPTIONS = {
    expandable: true,
    valueContent: '',
};
const TUI_MULTI_SELECT_OPTIONS = new InjectionToken('Default parameters for multi select component', {
    factory: () => TUI_MULTI_SELECT_DEFAULT_OPTIONS,
});
const tuiMultiSelectOptionsProvider = (options) => ({
    provide: TUI_MULTI_SELECT_OPTIONS,
    useValue: Object.assign(Object.assign({}, TUI_MULTI_SELECT_DEFAULT_OPTIONS), options),
});

var TuiMultiSelectComponent_1;
let TuiMultiSelectComponent = TuiMultiSelectComponent_1 = class TuiMultiSelectComponent extends AbstractTuiMultipleControl {
    constructor(control, changeDetectorRef, svgService, arrowMode, itemsHandlers, options, controller) {
        super(control, changeDetectorRef);
        this.arrowMode = arrowMode;
        this.itemsHandlers = itemsHandlers;
        this.options = options;
        this.controller = controller;
        this.stringify = this.itemsHandlers.stringify;
        this.identityMatcher = this.itemsHandlers.identityMatcher;
        this.expandable = this.options.expandable;
        this.search = '';
        this.editable = true;
        this.disabledItemHandler = this.itemsHandlers.disabledItemHandler;
        this.valueContent = this.options.valueContent;
        this.searchChange = new EventEmitter();
        this.datalist = '';
        this.open = false;
        this.valueMapper = (value, stringify, group) => group
            ? EMPTY_ARRAY
            : value.map(item => new TuiStringifiableItem(item, stringify));
        this.disabledItemHandlerWrapper = handler => stringifiable => typeof stringifiable === 'string' || handler(stringifiable.item);
        svgService.define({ iconBlank });
    }
    get size() {
        return this.controller.size;
    }
    get arrow() {
        return !this.interactive ? this.arrowMode.disabled : this.arrowMode.interactive;
    }
    get nativeFocusableElement() {
        return this.input ? this.input.nativeFocusableElement : null;
    }
    get focused() {
        return ((!!this.input && this.input.focused) ||
            (!!this.hostedDropdown && this.hostedDropdown.focused));
    }
    get computedValue() {
        return this.computedGroup ? EMPTY_ARRAY : this.value;
    }
    // @bad TODO: think of a better way
    get searchOrSpace() {
        return this.computedGroup ? ' ' : this.searchString;
    }
    get searchString() {
        return this.search === null ? '' : this.search;
    }
    /**
     * Pass empty icon to InputTag (inside this component)
     * to prevent overflow of arrow icon by many tags
     */
    get tagIcon() {
        return this.interactive ? 'iconBlank' : '';
    }
    get inputHidden() {
        return !this.editable && !this.computedGroup;
    }
    get computedGroup() {
        return (!!this.valueContent &&
            this.value.length > 0 &&
            (!this.focused || !this.editable));
    }
    get context() {
        return this.getContext(this.value);
    }
    getStringifier(stringify) {
        return ({ $implicit }) => stringify($implicit);
    }
    onHoveredChange(hovered) {
        this.updateHovered(hovered);
    }
    onSpace(event) {
        if (!this.editable) {
            event.preventDefault();
        }
        if (!this.readOnly) {
            this.open = true;
        }
    }
    handleOption(option) {
        const { value, identityMatcher } = this;
        const index = value.findIndex(item => identityMatcher(item, option));
        this.updateValue(index === -1 ? [...value, option] : value.filter((_, i) => i !== index));
        this.updateSearch(null);
    }
    onEnter(event) {
        const { value } = this;
        const options = this.accessor ? this.accessor.getOptions() : [];
        if (options.length !== 1) {
            return;
        }
        const index = value.indexOf(options[0]);
        event.preventDefault();
        this.updateValue(index === -1
            ? [...value, options[0]]
            : [...value.slice(0, index), ...value.slice(index + 1)]);
        this.updateSearch(null);
    }
    onClick({ nativeFocusableElement }) {
        var _a;
        if (this.editable &&
            this.interactive &&
            nativeFocusableElement &&
            isNativeFocused(nativeFocusableElement)) {
            (_a = this.hostedDropdown) === null || _a === void 0 ? void 0 : _a.updateOpen(!this.open);
        }
    }
    onArrowClick() {
        var _a;
        (_a = this.hostedDropdown) === null || _a === void 0 ? void 0 : _a.updateOpen(!this.open);
        this.focusInput();
    }
    onInput(value) {
        this.updateValue(value.map(({ item }) => item));
    }
    onSearch(search) {
        this.open = true;
        this.updateSearch(search);
    }
    onActiveZone(active) {
        this.updateFocused(active);
    }
    setDisabledState() {
        super.setDisabledState();
        this.open = false;
    }
    getContext($implicit) {
        return { $implicit };
    }
    updateSearch(search) {
        if (this.search === search) {
            return;
        }
        this.search = search;
        this.searchChange.emit(search);
    }
    focusInput(preventScroll = false) {
        if (this.nativeFocusableElement) {
            setNativeFocused(this.nativeFocusableElement, true, preventScroll);
        }
    }
};
TuiMultiSelectComponent.ɵfac = function TuiMultiSelectComponent_Factory(t) { return new (t || TuiMultiSelectComponent)(ɵngcc0.ɵɵdirectiveInject(NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(TuiSvgService), ɵngcc0.ɵɵdirectiveInject(TUI_ARROW_MODE), ɵngcc0.ɵɵdirectiveInject(TUI_ITEMS_HANDLERS), ɵngcc0.ɵɵdirectiveInject(TUI_MULTI_SELECT_OPTIONS), ɵngcc0.ɵɵdirectiveInject(TUI_TEXTFIELD_WATCHED_CONTROLLER)); };
TuiMultiSelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiMultiSelectComponent, selectors: [["tui-multi-select"]], contentQueries: function TuiMultiSelectComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiDataListDirective, 5, TemplateRef);
        ɵngcc0.ɵɵcontentQuery(dirIndex, TUI_DATA_LIST_ACCESSOR, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datalist = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.accessor = _t.first);
    } }, viewQuery: function TuiMultiSelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TuiHostedDropdownComponent, 5);
        ɵngcc0.ɵɵviewQuery(TuiInputTagComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.hostedDropdown = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, hostVars: 3, hostBindings: function TuiMultiSelectComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-size", ctx.size);
        ɵngcc0.ɵɵclassProp("_editable", ctx.editable);
    } }, inputs: { stringify: "stringify", identityMatcher: "identityMatcher", expandable: "expandable", search: "search", editable: "editable", disabledItemHandler: "disabledItemHandler", valueContent: "valueContent" }, outputs: { searchChange: "searchChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                useExisting: forwardRef(() => TuiMultiSelectComponent_1)
            },
            {
                provide: TUI_DATA_LIST_HOST,
                useExisting: forwardRef(() => TuiMultiSelectComponent_1)
            },
            FIXED_DROPDOWN_CONTROLLER_PROVIDER,
            TEXTFIELD_CONTROLLER_PROVIDER,
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 9, vars: 27, consts: [[1, "t-hosted", 3, "canOpen", "content", "open", "openChange", "tuiHoveredChange", "tuiActiveZoneChange"], ["tuiHostedDropdownHost", "", "automation-id", "tui-multi-select__input", 1, "input", 3, "nativeId", "icon", "disabled", "disabledItemHandler", "readOnly", "inputHidden", "pseudoHovered", "pseudoFocused", "pseudoInvalid", "editable", "expandable", "search", "ngModel", "ngModelChange", "searchChange", "keydown.space", "keydown.enter", "click.prevent"], ["inputTag", ""], [1, "t-wrapper"], ["polymorpheus-outlet", "", "class", "t-group", 3, "t-group_fullsize", "context", "content", 4, "ngIf"], ["polymorpheus-outlet", "", "automation-id", "tui-multi-select__arrow", "tuiPreventDefault", "mousedown", "class", "t-arrow", 3, "content", "click.prevent", 4, "ngIf"], ["polymorpheus-outlet", "", 1, "t-group", 3, "context", "content"], ["polymorpheus-outlet", "", "automation-id", "tui-multi-select__arrow", "tuiPreventDefault", "mousedown", 1, "t-arrow", 3, "content", "click.prevent"]], template: function TuiMultiSelectComponent_Template(rf, ctx) { if (rf & 1) {
        const _r5 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "tui-hosted-dropdown", 0);
        ɵngcc0.ɵɵlistener("openChange", function TuiMultiSelectComponent_Template_tui_hosted_dropdown_openChange_0_listener($event) { return ctx.open = $event; })("tuiHoveredChange", function TuiMultiSelectComponent_Template_tui_hosted_dropdown_tuiHoveredChange_0_listener($event) { return ctx.onHoveredChange($event); })("tuiActiveZoneChange", function TuiMultiSelectComponent_Template_tui_hosted_dropdown_tuiActiveZoneChange_0_listener($event) { return ctx.onActiveZone($event); });
        ɵngcc0.ɵɵelementStart(1, "tui-input-tag", 1, 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function TuiMultiSelectComponent_Template_tui_input_tag_ngModelChange_1_listener($event) { return ctx.onInput($event); })("searchChange", function TuiMultiSelectComponent_Template_tui_input_tag_searchChange_1_listener($event) { return ctx.onSearch($event); })("keydown.space", function TuiMultiSelectComponent_Template_tui_input_tag_keydown_space_1_listener($event) { return ctx.onSpace($event); })("keydown.enter", function TuiMultiSelectComponent_Template_tui_input_tag_keydown_enter_1_listener($event) { return ctx.onEnter($event); })("click.prevent", function TuiMultiSelectComponent_Template_tui_input_tag_click_prevent_1_listener() { ɵngcc0.ɵɵrestoreView(_r5); const _r0 = ɵngcc0.ɵɵreference(2); return ctx.onClick(_r0); });
        ɵngcc0.ɵɵpipe(3, "tuiMapper");
        ɵngcc0.ɵɵpipe(4, "tuiMapper");
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 3);
        ɵngcc0.ɵɵtemplate(7, TuiMultiSelectComponent_div_7_Template, 1, 4, "div", 4);
        ɵngcc0.ɵɵtemplate(8, TuiMultiSelectComponent_div_8_Template, 1, 1, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("canOpen", ctx.interactive)("content", ctx.datalist || "")("open", ctx.open);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("nativeId", ctx.nativeId)("icon", ctx.tagIcon)("disabled", ctx.disabled)("disabledItemHandler", ɵngcc0.ɵɵpipeBind2(3, 20, ctx.disabledItemHandler, ctx.disabledItemHandlerWrapper))("readOnly", ctx.readOnly)("inputHidden", !ctx.editable)("pseudoHovered", ctx.computedHovered)("pseudoFocused", ctx.computedFocused)("pseudoInvalid", ctx.computedInvalid)("editable", false)("expandable", ctx.expandable)("search", ctx.searchOrSpace)("ngModel", ɵngcc0.ɵɵpipeBind3(4, 23, ctx.computedValue, ctx.valueMapper, ctx.stringify));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵclassProp("t-wrapper_disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.computedGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.arrow);
    } }, directives: [ɵngcc1.TuiHostedDropdownComponent, ɵngcc2.TuiHoveredDirective, ɵngcc2.TuiActiveZoneDirective, ɵngcc3.TuiInputTagComponent, ɵngcc1.TuiHostedDropdownConnectorDirective, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc5.NgIf, ɵngcc6.PolymorpheusOutletComponent, ɵngcc2.TuiPreventDefaultDirective], pipes: [ɵngcc2.TuiMapperPipe], styles: ["[_nghost-%COMP%]{position:relative;display:block}._disabled[_nghost-%COMP%]{pointer-events:none}.t-hosted[_ngcontent-%COMP%]{display:block}[_nghost-%COMP%]:not(._editable):not(._readonly)   .input[_ngcontent-%COMP%]{cursor:pointer}.t-wrapper[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;pointer-events:none;justify-content:flex-end}.t-wrapper_disabled[_ngcontent-%COMP%]{opacity:var(--tui-disabled-opacity)}[data-size='s'][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]{height:var(--tui-height-s)}[data-size='m'][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]{height:var(--tui-height-m)}[data-size='l'][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]{height:var(--tui-height-l)}.t-group[_ngcontent-%COMP%]{display:flex;flex:1;align-items:center;padding:1.6875rem 1rem .5625rem}.t-group_fullsize[_ngcontent-%COMP%]{padding-top:.0625rem;padding-bottom:0}[data-size='m'][_nghost-%COMP%]   .t-group_fullsize.t-group_fullsize[_ngcontent-%COMP%]{padding-top:0}[data-size='m'][_nghost-%COMP%]   .t-group[_ngcontent-%COMP%]{padding:1.1875rem .75rem 0;font-size:.8125rem}.t-arrow[_ngcontent-%COMP%]{transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;display:flex;align-items:center;justify-content:center;color:var(--tui-text-03);position:relative;box-sizing:border-box;transition-property:color,transform;width:1.5rem;height:auto;margin:0 .75rem;pointer-events:auto;cursor:pointer}.t-arrow[_ngcontent-%COMP%]:hover{color:var(--tui-text-02)}._disabled[_nghost-%COMP%]   .t-arrow[_ngcontent-%COMP%], ._readonly[_nghost-%COMP%]   .t-arrow[_ngcontent-%COMP%]{pointer-events:none}[data-mode=onDark][_nghost-%COMP%]   .t-arrow[_ngcontent-%COMP%]{color:var(--tui-text-03-night)}[data-mode=onDark][_nghost-%COMP%]   .t-arrow[_ngcontent-%COMP%]:hover{color:var(--tui-text-01-night)}"], changeDetection: 0 });
TuiMultiSelectComponent.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NgControl,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] },
    { type: TuiSvgService, decorators: [{ type: Inject, args: [TuiSvgService,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_ARROW_MODE,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_ITEMS_HANDLERS,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_MULTI_SELECT_OPTIONS,] }] },
    { type: TuiTextfieldController, decorators: [{ type: Inject, args: [TUI_TEXTFIELD_WATCHED_CONTROLLER,] }] }
];
__decorate([
    ContentChild(TUI_DATA_LIST_ACCESSOR)
], TuiMultiSelectComponent.prototype, "accessor", void 0);
__decorate([
    ViewChild(TuiHostedDropdownComponent)
], TuiMultiSelectComponent.prototype, "hostedDropdown", void 0);
__decorate([
    ViewChild(TuiInputTagComponent)
], TuiMultiSelectComponent.prototype, "input", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiMultiSelectComponent.prototype, "stringify", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiMultiSelectComponent.prototype, "identityMatcher", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiMultiSelectComponent.prototype, "expandable", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiMultiSelectComponent.prototype, "search", void 0);
__decorate([
    Input(),
    HostBinding('class._editable'),
    tuiDefaultProp()
], TuiMultiSelectComponent.prototype, "editable", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiMultiSelectComponent.prototype, "disabledItemHandler", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiMultiSelectComponent.prototype, "valueContent", void 0);
__decorate([
    Output()
], TuiMultiSelectComponent.prototype, "searchChange", void 0);
__decorate([
    ContentChild(TuiDataListDirective, { read: TemplateRef })
], TuiMultiSelectComponent.prototype, "datalist", void 0);
__decorate([
    HostBinding('attr.data-size')
], TuiMultiSelectComponent.prototype, "size", null);
__decorate([
    tuiPure
], TuiMultiSelectComponent.prototype, "getStringifier", null);
__decorate([
    tuiPure
], TuiMultiSelectComponent.prototype, "getContext", null);
TuiMultiSelectComponent = TuiMultiSelectComponent_1 = __decorate([ __param(0, Optional()),
    __param(0, Self()),
    __param(0, Inject(NgControl)),
    __param(1, Inject(ChangeDetectorRef)),
    __param(2, Inject(TuiSvgService)),
    __param(3, Inject(TUI_ARROW_MODE)),
    __param(4, Inject(TUI_ITEMS_HANDLERS)),
    __param(5, Inject(TUI_MULTI_SELECT_OPTIONS)),
    __param(6, Inject(TUI_TEXTFIELD_WATCHED_CONTROLLER))
], TuiMultiSelectComponent);

let TuiHideSelectedPipe = class TuiHideSelectedPipe {
    constructor(component) {
        this.component = component;
    }
    transform(items, component) {
        const { value, identityMatcher } = component !== null && component !== void 0 ? component : this.component;
        if (!items) {
            return null;
        }
        return isFlat(items)
            ? this.filter(items, value, identityMatcher)
            : this.filter2d(items, value, identityMatcher);
    }
    filter2d(items, value, matcher) {
        return items.map(subItems => this.filter(subItems, value, matcher));
    }
    filter(items, value, matcher) {
        return items.filter(item => value.every(selected => !matcher(selected, item)));
    }
};
TuiHideSelectedPipe.ɵfac = function TuiHideSelectedPipe_Factory(t) { return new (t || TuiHideSelectedPipe)(ɵngcc0.ɵɵdirectiveInject(TuiMultiSelectComponent, 16)); };
TuiHideSelectedPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "tuiHideSelected", type: TuiHideSelectedPipe, pure: false });
TuiHideSelectedPipe.ctorParameters = () => [
    { type: TuiMultiSelectComponent, decorators: [{ type: Inject, args: [TuiMultiSelectComponent,] }] }
];
__decorate([
    tuiPure
], TuiHideSelectedPipe.prototype, "filter2d", null);
__decorate([
    tuiPure
], TuiHideSelectedPipe.prototype, "filter", null);
TuiHideSelectedPipe = __decorate([ __param(0, Inject(TuiMultiSelectComponent))
], TuiHideSelectedPipe);

let TuiMultiSelectGroupComponent = class TuiMultiSelectGroupComponent {
    constructor(host, control) {
        this.host = host;
        this.control = control;
        this.options = EMPTY_QUERY;
        this.label = '';
    }
    get size() {
        return (this.options.first && this.options.first.size) || 'm';
    }
    get checkboxSize() {
        return this.options.first && sizeBigger(this.options.first.size) ? 'l' : 'm';
    }
    get empty$() {
        return itemsQueryListObservable(this.options).pipe(map(({ length }) => !length));
    }
    get disabled$() {
        return itemsQueryListObservable(this.options).pipe(map(items => items.every(({ disabled }) => disabled)));
    }
    get value$() {
        return combineLatest(this.items$, this.valueChanges$).pipe(map(([items, current]) => {
            let result = false;
            for (let i = 0; i < items.length; i++) {
                const selected = current.some(selected => this.matcher(selected, items[i]));
                if ((!selected && result) || (selected && !result && i)) {
                    return null;
                }
                result = selected;
            }
            return result;
        }));
    }
    onClick(checked) {
        if (!this.control.control) {
            return;
        }
        const controlValue = this.control.value || [];
        const { values } = this;
        const filtered = controlValue.filter(current => values.every(item => !this.matcher(current, item)));
        this.control.control.setValue(checked ? filtered : [...filtered, ...values]);
    }
    get values() {
        return this.filter(getOriginalArrayFromQueryList(this.options));
    }
    get matcher() {
        return this.host.identityMatcher || TUI_DEFAULT_IDENTITY_MATCHER;
    }
    get items$() {
        return itemsQueryListObservable(this.options).pipe(map(options => options.map(({ value }) => value).filter(isPresent)));
    }
    get valueChanges$() {
        return tuiReplayedValueChangesFrom(this.control).pipe(map(value => value || []));
    }
    filter(items) {
        return items.map(({ value }) => value).filter(isPresent);
    }
};
TuiMultiSelectGroupComponent.ɵfac = function TuiMultiSelectGroupComponent_Factory(t) { return new (t || TuiMultiSelectGroupComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_DATA_LIST_HOST), ɵngcc0.ɵɵdirectiveInject(NgControl)); };
TuiMultiSelectGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiMultiSelectGroupComponent, selectors: [["tui-opt-group", "tuiMultiSelectGroup", ""]], contentQueries: function TuiMultiSelectGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiOptionComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.options = _t);
    } }, inputs: { label: "label" }, features: [ɵngcc0.ɵɵProvidersFeature([], [
            {
                provide: TUI_OPTION_CONTENT,
                useValue: null
            },
        ])], attrs: _c1, ngContentSelectors: _c0, decls: 3, vars: 3, consts: [[4, "tuiLet"], ["tuiOption", "", 3, "size", "disabled", "click", 4, "ngIf"], ["tuiOption", "", 3, "size", "disabled", "click"], [1, "t-checkbox", 3, "size", "value"], [1, "t-label"]], template: function TuiMultiSelectGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TuiMultiSelectGroupComponent_ng_container_0_Template, 3, 3, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵprojection(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("tuiLet", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.value$));
    } }, directives: [ɵngcc2.TuiLetDirective, ɵngcc5.NgIf, ɵngcc1.TuiOptionComponent, ɵngcc1.TuiPrimitiveCheckboxComponent], pipes: [ɵngcc5.AsyncPipe], styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column}[_nghost-%COMP%]:before{content:''}.t-label[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font:var(--tui-font-text-xs);flex:1;color:var(--tui-text-02)}.t-checkbox[_ngcontent-%COMP%]{margin-right:.75rem}"], changeDetection: 0 });
TuiMultiSelectGroupComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [TUI_DATA_LIST_HOST,] }] },
    { type: NgControl, decorators: [{ type: Inject, args: [NgControl,] }] }
];
__decorate([
    ContentChildren(TuiOptionComponent)
], TuiMultiSelectGroupComponent.prototype, "options", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiMultiSelectGroupComponent.prototype, "label", void 0);
__decorate([
    tuiPure
], TuiMultiSelectGroupComponent.prototype, "empty$", null);
__decorate([
    tuiPure
], TuiMultiSelectGroupComponent.prototype, "disabled$", null);
__decorate([
    tuiPure
], TuiMultiSelectGroupComponent.prototype, "value$", null);
__decorate([
    tuiPure
], TuiMultiSelectGroupComponent.prototype, "items$", null);
__decorate([
    tuiPure
], TuiMultiSelectGroupComponent.prototype, "valueChanges$", null);
__decorate([
    tuiPure
], TuiMultiSelectGroupComponent.prototype, "filter", null);
TuiMultiSelectGroupComponent = __decorate([ __param(0, Inject(TUI_DATA_LIST_HOST)),
    __param(1, Inject(NgControl))
], TuiMultiSelectGroupComponent);

function hostFallbackFactory(control, host) {
    return (host || {
        handleOption: option => {
            if (!control.control) {
                return;
            }
            const value = control.value || [];
            const index = value.indexOf(option);
            control.control.setValue(index === -1
                ? [...value, option]
                : [...value.slice(0, index), ...value.slice(index + 1)]);
        },
    });
}
const TUI_MULTI_SELECT_OPTION = new PolymorpheusComponent(TuiMultiSelectOptionComponent);
// TODO: remove in ivy compilation
const MULTI_SELECT_ACCESSOR = {
    writeValue: EMPTY_FUNCTION,
    registerOnChange: EMPTY_FUNCTION,
    registerOnTouched: EMPTY_FUNCTION,
};
let TuiMultiSelectGroupDirective = class TuiMultiSelectGroupDirective {
};
TuiMultiSelectGroupDirective.ɵfac = function TuiMultiSelectGroupDirective_Factory(t) { return new (t || TuiMultiSelectGroupDirective)(); };
TuiMultiSelectGroupDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiMultiSelectGroupDirective, selectors: [["", "tuiMultiSelectGroup", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_OPTION_CONTENT,
                useValue: TUI_MULTI_SELECT_OPTION
            },
            {
                provide: TUI_DATA_LIST_HOST,
                deps: [
                    NgControl,
                    [new Optional(), forwardRef(() => TuiMultiSelectComponent)],
                ],
                useFactory: hostFallbackFactory
            },
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useValue: MULTI_SELECT_ACCESSOR
            },
        ])] });

let TuiMultiSelectModule = class TuiMultiSelectModule {
};
TuiMultiSelectModule.ɵfac = function TuiMultiSelectModule_Factory(t) { return new (t || TuiMultiSelectModule)(); };
TuiMultiSelectModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiMultiSelectModule });
TuiMultiSelectModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            PolymorpheusModule,
            TuiPreventDefaultModule,
            TuiActiveZoneModule,
            TuiArrowModule,
            TuiLetModule,
            TuiMapperPipeModule,
            TuiHoveredModule,
            TuiSvgModule,
            TuiHostedDropdownModule,
            TuiInputTagModule,
            TuiMultiSelectOptionModule,
            TuiPrimitiveCheckboxModule,
            TuiDataListModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiMultiSelectComponent, [{
        type: Component,
        args: [{
                selector: 'tui-multi-select',
                template: "<tui-hosted-dropdown\n    class=\"t-hosted\"\n    [canOpen]=\"interactive\"\n    [content]=\"datalist || ''\"\n    [(open)]=\"open\"\n    (tuiHoveredChange)=\"onHoveredChange($event)\"\n    (tuiActiveZoneChange)=\"onActiveZone($event)\"\n>\n    <tui-input-tag\n        #inputTag\n        tuiHostedDropdownHost\n        automation-id=\"tui-multi-select__input\"\n        class=\"input\"\n        [nativeId]=\"nativeId\"\n        [icon]=\"tagIcon\"\n        [disabled]=\"disabled\"\n        [disabledItemHandler]=\"disabledItemHandler | tuiMapper: disabledItemHandlerWrapper\"\n        [readOnly]=\"readOnly\"\n        [inputHidden]=\"!editable\"\n        [pseudoHovered]=\"computedHovered\"\n        [pseudoFocused]=\"computedFocused\"\n        [pseudoInvalid]=\"computedInvalid\"\n        [editable]=\"false\"\n        [expandable]=\"expandable\"\n        [search]=\"searchOrSpace\"\n        [ngModel]=\"computedValue | tuiMapper: valueMapper:stringify\"\n        (ngModelChange)=\"onInput($event)\"\n        (searchChange)=\"onSearch($event)\"\n        (keydown.space)=\"onSpace($event)\"\n        (keydown.enter)=\"onEnter($event)\"\n        (click.prevent)=\"onClick(inputTag)\"\n    >\n        <ng-content></ng-content>\n    </tui-input-tag>\n    <div\n        class=\"t-wrapper\"\n        [class.t-wrapper_disabled]=\"disabled\"\n    >\n        <div\n            *ngIf=\"computedGroup\"\n            polymorpheus-outlet\n            class=\"t-group\"\n            [class.t-group_fullsize]=\"inputTag.labelOutside\"\n            [context]=\"context\"\n            [content]=\"valueContent\"\n        ></div>\n\n        <div\n            *ngIf=\"arrow\"\n            polymorpheus-outlet\n            automation-id=\"tui-multi-select__arrow\"\n            tuiPreventDefault=\"mousedown\"\n            class=\"t-arrow\"\n            [content]=\"arrow\"\n            (click.prevent)=\"onArrowClick()\"\n        ></div>\n    </div>\n</tui-hosted-dropdown>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                        useExisting: forwardRef(() => TuiMultiSelectComponent_1)
                    },
                    {
                        provide: TUI_DATA_LIST_HOST,
                        useExisting: forwardRef(() => TuiMultiSelectComponent_1)
                    },
                    FIXED_DROPDOWN_CONTROLLER_PROVIDER,
                    TEXTFIELD_CONTROLLER_PROVIDER,
                ],
                styles: [":host{position:relative;display:block}:host._disabled{pointer-events:none}.t-hosted{display:block}:host:not(._editable):not(._readonly) .input{cursor:pointer}.t-wrapper{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;pointer-events:none;justify-content:flex-end}.t-wrapper_disabled{opacity:var(--tui-disabled-opacity)}:host[data-size='s'] .t-wrapper{height:var(--tui-height-s)}:host[data-size='m'] .t-wrapper{height:var(--tui-height-m)}:host[data-size='l'] .t-wrapper{height:var(--tui-height-l)}.t-group{display:flex;flex:1;align-items:center;padding:1.6875rem 1rem .5625rem}.t-group_fullsize{padding-top:.0625rem;padding-bottom:0}:host[data-size='m'] .t-group_fullsize.t-group_fullsize{padding-top:0}:host[data-size='m'] .t-group{padding:1.1875rem .75rem 0;font-size:.8125rem}.t-arrow{transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;display:flex;align-items:center;justify-content:center;color:var(--tui-text-03);position:relative;box-sizing:border-box;transition-property:color,transform;width:1.5rem;height:auto;margin:0 .75rem;pointer-events:auto;cursor:pointer}.t-arrow:hover{color:var(--tui-text-02)}:host._disabled .t-arrow,:host._readonly .t-arrow{pointer-events:none}:host[data-mode=onDark] .t-arrow{color:var(--tui-text-03-night)}:host[data-mode=onDark] .t-arrow:hover{color:var(--tui-text-01-night)}"]
            }]
    }], function () { return [{ type: ɵngcc4.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }, {
                type: Inject,
                args: [NgControl]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }, { type: ɵngcc1.TuiSvgService, decorators: [{
                type: Inject,
                args: [TuiSvgService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_ARROW_MODE]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_ITEMS_HANDLERS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_MULTI_SELECT_OPTIONS]
            }] }, { type: ɵngcc1.TuiTextfieldController, decorators: [{
                type: Inject,
                args: [TUI_TEXTFIELD_WATCHED_CONTROLLER]
            }] }]; }, { stringify: [{
            type: Input
        }], identityMatcher: [{
            type: Input
        }], expandable: [{
            type: Input
        }], search: [{
            type: Input
        }], editable: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class._editable']
        }], disabledItemHandler: [{
            type: Input
        }], valueContent: [{
            type: Input
        }], searchChange: [{
            type: Output
        }], datalist: [{
            type: ContentChild,
            args: [TuiDataListDirective, { read: TemplateRef }]
        }], size: [{
            type: HostBinding,
            args: ['attr.data-size']
        }], accessor: [{
            type: ContentChild,
            args: [TUI_DATA_LIST_ACCESSOR]
        }], hostedDropdown: [{
            type: ViewChild,
            args: [TuiHostedDropdownComponent]
        }], input: [{
            type: ViewChild,
            args: [TuiInputTagComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiHideSelectedPipe, [{
        type: Pipe,
        args: [{
                name: 'tuiHideSelected',
                pure: false
            }]
    }], function () { return [{ type: TuiMultiSelectComponent, decorators: [{
                type: Inject,
                args: [TuiMultiSelectComponent]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiMultiSelectGroupComponent, [{
        type: Component,
        args: [{
                selector: 'tui-opt-group[tuiMultiSelectGroup]',
                template: "<ng-container *tuiLet=\"value$ | async as value\">\n    <button\n        *ngIf=\"label && !(empty$ | async)\"\n        tuiOption\n        [size]=\"size\"\n        [disabled]=\"!!(disabled$ | async)\"\n        (click)=\"onClick(value)\"\n    >\n        <tui-primitive-checkbox\n            class=\"t-checkbox\"\n            [size]=\"checkboxSize\"\n            [value]=\"value\"\n        ></tui-primitive-checkbox>\n        <span class=\"t-label\">{{ label }}</span>\n    </button>\n</ng-container>\n<ng-content></ng-content>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                viewProviders: [
                    {
                        provide: TUI_OPTION_CONTENT,
                        useValue: null
                    },
                ],
                styles: [":host{display:flex;flex-direction:column}:host:before{content:''}.t-label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font:var(--tui-font-text-xs);flex:1;color:var(--tui-text-02)}.t-checkbox{margin-right:.75rem}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [TUI_DATA_LIST_HOST]
            }] }, { type: ɵngcc4.NgControl, decorators: [{
                type: Inject,
                args: [NgControl]
            }] }]; }, { options: [{
            type: ContentChildren,
            args: [TuiOptionComponent]
        }], label: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiMultiSelectGroupDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiMultiSelectGroup]',
                providers: [
                    {
                        provide: TUI_OPTION_CONTENT,
                        useValue: TUI_MULTI_SELECT_OPTION
                    },
                    {
                        provide: TUI_DATA_LIST_HOST,
                        deps: [
                            NgControl,
                            [new Optional(), forwardRef(() => TuiMultiSelectComponent)],
                        ],
                        useFactory: hostFallbackFactory
                    },
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useValue: MULTI_SELECT_ACCESSOR
                    },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiMultiSelectModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    PolymorpheusModule,
                    TuiPreventDefaultModule,
                    TuiActiveZoneModule,
                    TuiArrowModule,
                    TuiLetModule,
                    TuiMapperPipeModule,
                    TuiHoveredModule,
                    TuiSvgModule,
                    TuiHostedDropdownModule,
                    TuiInputTagModule,
                    TuiMultiSelectOptionModule,
                    TuiPrimitiveCheckboxModule,
                    TuiDataListModule,
                ],
                declarations: [
                    TuiMultiSelectComponent,
                    TuiMultiSelectGroupComponent,
                    TuiMultiSelectGroupDirective,
                    TuiHideSelectedPipe,
                ],
                exports: [
                    TuiMultiSelectComponent,
                    TuiMultiSelectGroupComponent,
                    TuiMultiSelectGroupDirective,
                    TuiHideSelectedPipe,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiMultiSelectModule, { declarations: function () { return [TuiMultiSelectComponent, TuiMultiSelectGroupComponent, TuiMultiSelectGroupDirective, TuiHideSelectedPipe]; }, imports: function () { return [CommonModule,
        FormsModule,
        PolymorpheusModule,
        TuiPreventDefaultModule,
        TuiActiveZoneModule,
        TuiArrowModule,
        TuiLetModule,
        TuiMapperPipeModule,
        TuiHoveredModule,
        TuiSvgModule,
        TuiHostedDropdownModule,
        TuiInputTagModule,
        TuiMultiSelectOptionModule,
        TuiPrimitiveCheckboxModule,
        TuiDataListModule]; }, exports: function () { return [TuiMultiSelectComponent, TuiMultiSelectGroupComponent, TuiMultiSelectGroupDirective, TuiHideSelectedPipe]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MULTI_SELECT_ACCESSOR, TUI_MULTI_SELECT_DEFAULT_OPTIONS, TUI_MULTI_SELECT_OPTION, TUI_MULTI_SELECT_OPTIONS, TuiHideSelectedPipe, TuiMultiSelectComponent, TuiMultiSelectGroupComponent, TuiMultiSelectGroupDirective, TuiMultiSelectModule, hostFallbackFactory, tuiMultiSelectOptionsProvider };

